export default __webpack_public_path__ + "static/media/linkedin.8c90e740.svg";